export default {"src":"/_next/static/media/contract-green.29c79962.svg","height":29,"width":29,"blurWidth":0,"blurHeight":0};